<div class="main-wrap">
  <p-menu [model]="navigationService.items"></p-menu>
</div>